'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _social_twitter2x = require('../../assets/social_twitter@2x.png');

var _social_twitter2x2 = _interopRequireDefault(_social_twitter2x);

var _social_facebook2x = require('../../assets/social_facebook@2x.png');

var _social_facebook2x2 = _interopRequireDefault(_social_facebook2x);

var _social_linkedin2x = require('../../assets/social_linkedin@2x.png');

var _social_linkedin2x2 = _interopRequireDefault(_social_linkedin2x);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function Social(p) {
    var title = p.title ? _react2['default'].createElement(
        'h2',
        { style: { marginBottom: 30 } },
        p.title
    ) : null;

    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations__social', style: { marginTop: 50 } },
        title,
        _react2['default'].createElement(
            'a',
            { href: p.twitterLink, target: '_blank', rel: 'noopener noreferrer' },
            _react2['default'].createElement('img', { src: _social_twitter2x2['default'], alt: 'twitter share' })
        ),
        _react2['default'].createElement(
            'a',
            { href: p.facebookLink, target: '_blank', rel: 'noopener noreferrer' },
            _react2['default'].createElement('img', { src: _social_facebook2x2['default'], alt: 'facebook share', className: 'facebook-share' })
        ),
        _react2['default'].createElement(
            'a',
            { href: p.linkedInLink, target: '_blank', rel: 'noopener noreferrer' },
            _react2['default'].createElement('img', { src: _social_linkedin2x2['default'], alt: 'linkedin share' })
        )
    );
}

module.exports = Social;


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/social-section.jsx
 ** module id = 1242
 ** module chunks = 0
 **/